
export function handleSortFio(arr, sortArr, field = 'calc_fio') {
    arr.sort((a, b) => {
        const aVal = a[field] ?? ''
        const bVal = b[field] ?? ''
        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return sortArr ? aVal - bVal : bVal - aVal
        }
        return sortArr
            ? String(aVal).localeCompare(String(bVal), 'ru')
            : String(bVal).localeCompare(String(aVal), 'ru')
    })
}